import { Dc, Diplome, Langue } from '../entities/dossier';

export class Dcc {
    _id : String;
    user : String;
    dc:        Dc;
    status : String;
    diplomes : Diplome[];
    langues:   Langue[];
}



// WEBPACK FOOTER //
// ./src/app/entities/dcc.ts